import React, {Component} from 'react'
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper'

const styles = {
    paper: {
        margin: "auto",
        marginTop: 200,
        width: "40%",
        padding: 15,
        textAlign: "center"
    }
}

export default class ContentPage extends Component {
    render() {
        return (
            <Paper elevation={4} style={styles.paper}>
                <Typography>Content - 1</Typography>
            </Paper>
        )
    }
}
